import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { InputComponent } from './input.component';

@Component({
  selector: 'app-html-input',
  template: `
    <app-icon class="ico" *ngIf="icon" [icon]="icon"></app-icon>
    <div
      class="inp"
      [attr.contenteditable]="type === 'text'"
      [attr.name]="name"
      [attr.inputmode]="inputmode"
      [attr.ph]="placeholder"
      #input>
      <ng-content></ng-content>
    </div>
    <ng-content select="button"></ng-content>
    <app-input-extras *ngIf="extras" class="extras" [extras]="extras"></app-input-extras>
  `,
  styleUrls: ['./styles/input.scss', './styles/input-validation.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
    {
      provide: InputComponent,
      useExisting: forwardRef(() => HtmlInputComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HtmlInputComponent extends InputComponent {
  protected override getInputValue(): string {
    return this.inputRef.nativeElement.innerText;
  }

  protected override setInputValue(v: string): void {
    this.inputRef.nativeElement.innerText = v;
  }
}
